// extracted by mini-css-extract-plugin
export default {"selection-badge":"singleClientReportTable_selection-badge__02vDA"};